/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function RocketIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "rocket", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M12.5 7.50001C10.1 9.90001 9 14 9 14L11 16C11 16 15.7492 14.2508 17.5 12.5C20.5 9.5 20.5 4.50001 20.5 4.50001C20.5 4.50001 15.5 4.50001 12.5 7.50001Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M11 9.5L4.5 12.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M15.5 14L12.5 20.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 15, cy: 10, r: 1.5, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9 14C9 14 7.54688 14.9531 6.5 16C5.5 17 4.5 20.5 4.5 20.5C4.5 20.5 8 19.5 9 18.5C10 17.5 11 16 11 16", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(RocketIcon);
export default ForwardRef;
//# sourceMappingURL=rocketIcon.js.map